/**
 * AWS Cognito Configuration for Admin Frontend
 */

export const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
};

/**
 * Get the full Cognito hosted UI URL
 */
export const getCognitoHostedUIUrl = (): string => {
  return `https://${cognitoConfig.domain}.auth.${cognitoConfig.region}.amazoncognito.com`;
};
